const actions = {
  COHORT_TO_REQUEST: 'COHORT_TO_REQUEST',
  COHORT_TO_REQUEST_ERROR: 'COHORT_TO_REQUEST_ERROR',
  FETCH_REQUEST_COHORTS: 'FETCH_REQUEST_COHORTS',
  FETCH_REQUEST_QUERIES: 'FETCH_REQUEST_QUERIES',
  SHOW_REQUEST_COHORTS: 'SHOW_REQUEST_COHORTS',
  TOGGLE_REQUEST_COHORT_SELECTED: 'TOGGLE_REQUEST_COHORT_SELECTED',
  UPDATE_REQUEST_COHORTS_FILTER: 'UPDATE_REQUEST_COHORTS_FILTER',
  UPDATE_REQUEST_COHORTS_FLAGS: 'UPDATE_REQUEST_COHORTS_FLAGS',
  UPDATE_REQUEST_QUERIES: 'UPDATE_REQUEST_QUERIES',
};

export default actions;
